import { CoSoService } from "../services/coso.service";

var state = {
    cosoes: []
};

var getters = {};

var mutations = {
    getCoSoes(state, data) {
        state.cosoes = [...data];
    },
};

var actions = {
    getCoSoes({ commit }) {
        return CoSoService.getCoSoes()
            .then(async (response) => {
                if (response.status === 200)
                    await commit("getCoSoes", response.data);
                return response;
            })
            .catch((error) => error.message);
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
